// extracted by mini-css-extract-plugin
var _1 = "ProductQuantity_productQuantity__51iQG";
export { _1 as "productQuantity" }
